import { Dimensions, Platform, View } from "react-native";
import VStack from "../ui_atoms/VStack";
import React from "react";

type StoryStackNavigatorContainerProps = {
    children: React.ReactNode;
};
export const StoryStackNavigatorContainer: React.FC<StoryStackNavigatorContainerProps> = ({
    children,
}) => {
    if (Platform.OS === "web") {
        return (
            <View
                style={{
                    marginLeft: 0,
                    height: Dimensions.get("window").height,
                    width: Dimensions.get("window").width,
                }}
            >
                {children}
            </View>
        );
    }
    return (
        <VStack
            style={{
                alignItems: "stretch",
                alignSelf: "stretch",
                flex: 1,
            }}
        >
            {children}
        </VStack>
    );
};
